import { SVGProps, Ref, forwardRef } from 'react';

export const DocumentOutlinedSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M14 5.955V15.5H2V.5h6.667C12.667.5 14 1.864 14 5.955m-1.4 0V14.1H3.4V1.9h5.267c1.916 0 2.747.344 3.165.772.428.437.768 1.31.768 3.283m-1.603 1.077H5v-1.4h5.998zm0 3.332H5v-1.4h5.998z"
                fill="currentColor"
            />
        </g>
    </svg>
));
DocumentOutlinedSize16Glyph.displayName = 'DocumentOutlinedSize16Glyph';
